import ContentAsset, {
	ContentAssetNewProps,
} from "@components/BasicComponents/ContentAsset/ContentAsset"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import React from "react"

const TitleSection = (props: ContentAssetNewProps) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<ContentAsset
						data={props.data}
						direction={"left"}
						shortDesc={props.shortDesc}
					/>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default TitleSection
